/* eslint-disable max-lines-per-function */
import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Table from '../../../components/layout/Table'
import Modal from '../../../components/popup/Modal'
import xacMinhVanBangProcessor from '../../../processor/xacMinhVanBangProcessor'

export default function LichSuXacMinh(props) {
  const { toggle, vanBang } = props
  const toast = useSelector((store) => store.notify.toast)
  const confirm = useSelector((store) => store.notify.confirm)
  const [xacMinhVanBangs, setXacMinhVanBangs] = useState([])

  useEffect(async () => {
    if (vanBang) {
      const rs = await xacMinhVanBangProcessor.getXacMinhVanBang(vanBang.id)
      if (rs.isSuccess) {
        setXacMinhVanBangs(rs.data)
      }
    }
  }, [vanBang])

  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button
        label="Huỷ"
        className="p-button-secondary mr-2"
        onClick={() => {
          if (toggle) toggle()
        }}
      />
    </div>
  )

  const deleteOnClick = async (id) => {
    const rs = await xacMinhVanBangProcessor.delete(id)
    toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
    if (rs.isSuccess) setXacMinhVanBangs([...xacMinhVanBangs.filter((item) => item.id !== id)])
  }

  const column = [
    { value: 'kinhGui', name: 'Đơn vị yêu cầu xác minh' },
    { value: 'congVanSo', name: 'Công văn số' },
    { value: 'ngay', name: 'Ngày xác minh' },
    {
      value: 'fileXacMinh',
      name: 'File xác minh',
      render: (data) => (
        <a href={data.fileXacMinh} download>
          Tải file
        </a>
      ),
    },
    {
      value: 'tapTin',
      name: 'Tập tin',
      render: (data) =>
        data.tapTin && (
          <a href={data.tapTin} download>
            Tải file
          </a>
        ),
    },
    {
      value: 'fileDanhSach',
      name: 'Danh sách đính kèm',
      render: (data) =>
        data.fileDanhSach && (
          <a href={data.fileDanhSach} download>
            Tải file
          </a>
        ),
    },
    {
      name: 'Chức năng',
      alignHeader: 'center',
      render: (data) => {
        return (
          <div className="flex justify-content-center">
            <Button
              icon="pi pi-trash"
              className="p-button-rounded p-button-danger mr-2"
              onClick={() => {
                confirm({
                  action: () => deleteOnClick(data.id),
                  body: `Bạn có muốn xoá văn bản xác nhận này?`,
                })
              }}
              tooltip="Xoá"
              tooltipOptions={{ position: 'top' }}
            />
          </div>
        )
      },
    },
  ]

  return (
    <>
      <Modal
        {...props}
        width="80%"
        footer={footer}
        header={`Văn bằng của ${vanBang && vanBang.hoTen}`}
      >
        <div className="flex flex-column">
          <div className="flex justify-content-start">
            <h4>Thông tin cần bổ sung</h4>
          </div>
          <Table data={xacMinhVanBangs} column={column} />
        </div>
      </Modal>
    </>
  )
}
